/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimDto } from './ClaimDto';
import {
    ClaimDtoFromJSON,
    ClaimDtoFromJSONTyped,
    ClaimDtoToJSON,
    ClaimDtoToJSONTyped,
} from './ClaimDto';

/**
 * 
 * @export
 * @interface CopropertyClaimsHistoryDto
 */
export interface CopropertyClaimsHistoryDto {
    /**
     * 
     * @type {Date}
     * @memberof CopropertyClaimsHistoryDto
     */
    periodStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CopropertyClaimsHistoryDto
     */
    periodEnd?: Date | null;
    /**
     * 
     * @type {Array<ClaimDto>}
     * @memberof CopropertyClaimsHistoryDto
     */
    claims?: Array<ClaimDto>;
    /**
     * Undertaking « Aucun sinistre n'a été déclaré sur les 3 dernières années ».
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    noClaimsLast3Years?: boolean | null;
    /**
     * Undertaking « Le risque n'est pas assuré et aucun sinistre n'est connu ».
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    notInsuredNoKnownClaims?: boolean | null;
    /**
     * At least one guarantee carries a declared claim — the claims statement becomes mandatory at contractualisation and the undertakings are no longer asked.
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    hasDeclaredClaims?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    insuredLast36Months?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    coverageInterruptionLast36Months?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CopropertyClaimsHistoryDto
     */
    coverageInterruptionStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CopropertyClaimsHistoryDto
     */
    coverageInterruptionEnd?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    terminationLast36Months?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyClaimsHistoryDto
     */
    terminationReason?: string | null;
    /**
     * Mutual recourse waiver, including towards the insurer.
     * @type {boolean}
     * @memberof CopropertyClaimsHistoryDto
     */
    mutualRecourseWaiver?: boolean | null;
}

/**
 * Check if a given object implements the CopropertyClaimsHistoryDto interface.
 */
export function instanceOfCopropertyClaimsHistoryDto(value: object): value is CopropertyClaimsHistoryDto {
    return true;
}

export function CopropertyClaimsHistoryDtoFromJSON(json: any): CopropertyClaimsHistoryDto {
    return CopropertyClaimsHistoryDtoFromJSONTyped(json, false);
}

export function CopropertyClaimsHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyClaimsHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ClaimDtoFromJSON)),
        'noClaimsLast3Years': json['noClaimsLast3Years'] == null ? undefined : json['noClaimsLast3Years'],
        'notInsuredNoKnownClaims': json['notInsuredNoKnownClaims'] == null ? undefined : json['notInsuredNoKnownClaims'],
        'hasDeclaredClaims': json['hasDeclaredClaims'] == null ? undefined : json['hasDeclaredClaims'],
        'insuredLast36Months': json['insuredLast36Months'] == null ? undefined : json['insuredLast36Months'],
        'coverageInterruptionLast36Months': json['coverageInterruptionLast36Months'] == null ? undefined : json['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': json['coverageInterruptionStart'] == null ? undefined : (new Date(json['coverageInterruptionStart'])),
        'coverageInterruptionEnd': json['coverageInterruptionEnd'] == null ? undefined : (new Date(json['coverageInterruptionEnd'])),
        'terminationLast36Months': json['terminationLast36Months'] == null ? undefined : json['terminationLast36Months'],
        'terminationReason': json['terminationReason'] == null ? undefined : json['terminationReason'],
        'mutualRecourseWaiver': json['mutualRecourseWaiver'] == null ? undefined : json['mutualRecourseWaiver'],
    };
}

export function CopropertyClaimsHistoryDtoToJSON(json: any): CopropertyClaimsHistoryDto {
    return CopropertyClaimsHistoryDtoToJSONTyped(json, false);
}

export function CopropertyClaimsHistoryDtoToJSONTyped(value?: CopropertyClaimsHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart'] as any).toISOString()),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd'] as any).toISOString()),
        'claims': value['claims'] == null ? undefined : ((value['claims'] as Array<any>).map(ClaimDtoToJSON)),
        'noClaimsLast3Years': value['noClaimsLast3Years'],
        'notInsuredNoKnownClaims': value['notInsuredNoKnownClaims'],
        'hasDeclaredClaims': value['hasDeclaredClaims'],
        'insuredLast36Months': value['insuredLast36Months'],
        'coverageInterruptionLast36Months': value['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': value['coverageInterruptionStart'] == null ? undefined : ((value['coverageInterruptionStart'] as any).toISOString()),
        'coverageInterruptionEnd': value['coverageInterruptionEnd'] == null ? undefined : ((value['coverageInterruptionEnd'] as any).toISOString()),
        'terminationLast36Months': value['terminationLast36Months'],
        'terminationReason': value['terminationReason'],
        'mutualRecourseWaiver': value['mutualRecourseWaiver'],
    };
}

